export const INITIAL_STATE = {
    extensionMessage: null,
};
